import { cn } from '@/lib/utils'
import { useAgentName } from './agentName'

interface BottomNavProps {
  onToggle?: () => void
  /** Held open — the tab reads as the active surface while the panel is up. */
  active?: boolean
}

/**
 * A thin bar pinned to the bottom of the frame, carrying the agent as a tab at
 * the far right — Linear's placement. Sits outside the scrolling page, so it
 * stays put wherever the customer is, and opens the same panel the avatar does.
 */
export function BottomNav({ onToggle, active }: BottomNavProps) {
  const agentName = useAgentName()

  return (
    <div className="border-ink-100 flex h-9 shrink-0 items-stretch justify-end border-t bg-white px-3">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={active}
        className={cn(
          'text-ink hover:bg-brand-100 border-ink-100 -mb-px flex items-center gap-1.5 self-end rounded-t-md border border-b-0 px-3 py-1.5 text-xs font-medium',
          active && 'bg-brand-100'
        )}
      >
        Ask {agentName}
      </button>
    </div>
  )
}
